module.exports = __webpack_public_path__ + "img/sl-3.webp";